import React from 'react'

const Register = ()=>{
  const handleSubmit =(e)=>{
    e.preventDefault();
    console.log("success submitted")
  }
  return(
    <div className="login-container">
       <section className="auth-container">
          <div className="card-container centered">
             <form onSubmit={handleSubmit}>
              <h1>Join <span className="app-text">boogiee</span> Community</h1>
              <p>Create any account to start listening musics.</p>
               <div className="form-container">
                 <label htmlFor="names">Full Names</label>
                 <div className="input-group">
                 <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-user"></i></span>
                </div>
                 <input 
                 type="text" 
                 id="names"
                 name="names"
                 className="form-control app-input"
                 placeholder="John Doe"
                 autoComplete="off"
                 />
                 </div>
               </div>

               <div className="form-container">
                 <label htmlFor="username">Username</label>
                 <div className="input-group">
                 <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-user"></i></span>
                </div>
                 <input 
                 type="text" 
                 id="username"
                 name="username"
                 className="form-control app-input"
                 placeholder="john.doe"
                 autoComplete="off"
                 />
               </div>
               </div>

               <div className="form-container">
                 <label htmlFor="email">Email</label>                 <div className="input-group">
                 <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-envelope"></i></span>
                </div>

                 <input 
                 type="email" 
                 id="email"
                 name="email"
                 className="form-control app-input"
                 placeholder="johndoe@gmail.com"
                 autoComplete="off"
                 />
               </div>
               </div>

               <div className="form-container">
                 <label htmlFor="password">Password</label>
                 <div className="input-group">
                 <div className="input-group-prepend">
                <span className="input-group-text"><i className="fa fa-lock"></i></span>
                </div>
                 <input 
                 type="password" 
                 id="password"
                 name="password"
                 className="form-control app-input"
                 placeholder="*****"
                 />
               </div>
              </div>
               <div className="form-container">
                 <button type="submit" className="btn submit-btn">Sign up</button>
                 &emsp;<span>Already have any account? <a href="/signin">Sign in</a></span>
               </div>
             </form>
       </div>
    </section>
    </div>
  )
}

export default Register;